import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "type-bus-form flex-col flex relative h-full overflow-x-hidden",
  style: {"overflow-y":"auto"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title-form py-5 mb-6 flex items-center justify-between" }, [
  /*#__PURE__*/_createVNode("h6", { class: "font-bold" }, "Tambah Tipe Barang")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_4 = { class: "p-field mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = {
  key: 1,
  class: "p-field mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "p-error text-sm" }, "Semua tipe barang telah didaftarkan", -1)
const _hoisted_8 = { class: "btn-action w-full mt-auto mb-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("form", {
      class: "flex-col flex h-full mx-3",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      (_ctx.canAddItem)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", {
                for: "listItem",
                class: {'p-error':_ctx.v$.itemId.$invalid && _ctx.submitted, 'text-body2': true}
              }, "Tipe Barang", 2),
              _createVNode(_component_Dropdown, {
                class: "flex-auto mt-1 input-primary",
                modelValue: _ctx.v$.itemId.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.itemId.$model = $event)),
                options: _ctx.itemOptions,
                optionValue: "value",
                optionLabel: "label",
                placeholder: "Pilih tipe barang"
              }, null, 8, ["modelValue", "options"]),
              ((_ctx.v$.itemId.$invalid && _ctx.submitted) || _ctx.v$.itemId.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString(_ctx.v$.itemId.required.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7
          ])),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Button, {
          label: "Simpan",
          disabled: !_ctx.canAddItem,
          class: "font-semibold p-button-sm btn-primary px-10 mr-2",
          type: "submit"
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black p-button-sm px-10 py-1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeSidebar()))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ], 32)
  ]))
}